import { axiosClient } from '../../clients/axios-client'
import type { FileRenewResponseDto } from './dtos/file'
import { FileRenewResponseDtoSchema } from './dtos/file'

export interface FileRenewResult {
  uploadedAt: string
  expiresAt: string
}

export async function renewFile(fileId: string): Promise<FileRenewResult> {
  try {
    const { data } = await axiosClient.post<FileRenewResponseDto>(`/filepool/files/${fileId}/renew`)

    const { uploaded_at, expires_at } = FileRenewResponseDtoSchema.parse(data)

    return {
      uploadedAt: uploaded_at,
      expiresAt: expires_at,
    }
  } catch (error) {
    console.error(`Renewing file failed. File id: ${fileId}`, error)
    throw error
  }
}
